












































import { Component, Vue } from 'vue-property-decorator'

import { AppData } from './appData'
import { Policy } from './policy'

@Component
export default class App extends Vue {
  private selectedPolicyHtml: string | null = null;
  private policies: Policy[] = [];

  public async created () {
    const data = this.$root.$data as AppData

    this.policies = data.policies
    const locale = data.locale

    const localePolicy = this.policies.find(p => p.locale === locale)

    if (localePolicy) {
      this.selectedPolicyHtml = localePolicy.html
    } else {
      this.selectedPolicyHtml = this.policies.length > 0 ? this.policies[0].html : null
    }
  }
}
